var React = require('react');

function Edit (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"d":"M87,29c-2.209,0-4,1.791-4,4v44c0,2.21-1.79,4-4,4H15c-2.21,0-4-1.79-4-4V13c0-2.21,1.79-4,4-4h44c2.209,0,4-1.791,4-4\n\t\ts-1.791-4-4-4H15C8.373,1,3,6.373,3,13v64c0,6.627,5.373,12,12,12h64c6.627,0,12-5.373,12-12V33C91,30.791,89.209,29,87,29z","key":0}),React.createElement("path",{"d":"M52.172,39.829C52.952,40.609,53.977,41,55,41s2.048-0.391,2.828-1.171l32-32c1.562-1.562,1.562-4.095,0-5.657\n\t\tc-1.561-1.562-4.096-1.562-5.656,0l-32,32C50.609,35.734,50.609,38.266,52.172,39.829z","key":1})]));
}

Edit.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"96px","height":"96px","viewBox":"0 0 96 96","enableBackground":"new 0 0 96 96","xmlSpace":"preserve"};

module.exports = Edit;

Edit.default = Edit;
